import { render, staticRenderFns } from "./comQuickPay.vue?vue&type=template&id=d8818f1c&scoped=true"
import script from "./comQuickPay.vue?vue&type=script&lang=js"
export * from "./comQuickPay.vue?vue&type=script&lang=js"
import style0 from "./comQuickPay.vue?vue&type=style&index=0&id=d8818f1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8818f1c",
  null
  
)

export default component.exports